import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  className = ''
}: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = Array.from({
    length: totalPages
  }, (_, i) => i + 1);
  // Simple pagination logic for mockup (shows all pages or a subset if too many)
  let visiblePages = pages;
  if (totalPages > 7) {
    if (currentPage <= 4) {
      visiblePages = [...pages.slice(0, 5), -1, totalPages];
    } else if (currentPage >= totalPages - 3) {
      visiblePages = [1, -1, ...pages.slice(totalPages - 5)];
    } else {
      visiblePages = [1, -1, currentPage - 1, currentPage, currentPage + 1, -1, totalPages];
    }
  }
  return <nav className={`flex items-center justify-center space-x-1 ${className}`} aria-label="Pagination" data-id="element-17373">
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 disabled:opacity-50 disabled:pointer-events-none transition-colors" aria-label="Previous page" data-id="element-17374">
        <ChevronLeft className="w-5 h-5" data-id="element-17375" />
      </button>

      {visiblePages.map((page, index) => {
      if (page === -1) {
        return <span key={`ellipsis-${index}`} className="px-3 py-2 text-slate-500" data-id="element-17376">
              ...
            </span>;
      }
      const isActive = page === currentPage;
      return <button key={page} onClick={() => onPageChange(page)} className={`
              min-w-[40px] h-10 px-3 rounded-lg text-sm font-medium transition-colors
              ${isActive ? 'bg-primary text-white' : 'text-slate-700 hover:bg-slate-100'}
            `} aria-current={isActive ? 'page' : undefined} data-id="element-17377">
            {page}
          </button>;
    })}

      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 disabled:opacity-50 disabled:pointer-events-none transition-colors" aria-label="Next page" data-id="element-17378">
        <ChevronRight className="w-5 h-5" data-id="element-17379" />
      </button>
    </nav>;
}